import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";

// Function to strip HTML tags but keep links
const stripHtmlButKeepLinks = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const elements = doc.body.childNodes;
  let result = "";

  elements.forEach((element) => {
    if (element.nodeType === Node.TEXT_NODE) {
      result += element.textContent;
    } else if (element.nodeType === Node.ELEMENT_NODE) {
      if (element.tagName === "A") {
        result += `<a href="${element.getAttribute("href")}">${
          element.textContent
        }</a>`;
      } else {
        result += element.textContent;
      }
    }
  });

  return result;
};

const HelpContent = () => {
  const [content, setContent] = useState("");
  const documentId = "Jg8gcVVi7HA2vNZIEvn6";

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const docRef = doc(db, "pages", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const rawContent = docSnap.data().content;
          //console.log("Raw Content:", rawContent); // Debugging log
          const processedContent = stripHtmlButKeepLinks(rawContent);
          //console.log("Processed Content:", processedContent); // Debugging log
          setContent(processedContent);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchContent();
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

export default HelpContent;
